import React from "react";
import { Grid,Container, Divider } from 'semantic-ui-react';
import Field from "../../components/forms/field";
import FormattedDate from "../../components/formatters/formattedDate";
import CaseUpdate from "./case-update"
import { AuthService } from '../../services/auth-service'


function convertNewlineToBreakWithFormattedDate(text) {

    if (!text || text === "") {
        return { __html: "" };
      }
    const lines = text.split("\n");
    const formattedLines = lines.map(line => {
      const dateRegex = /\b(\d{8})\b/;
      const dateMatch = line.match(dateRegex);
  
      if (dateMatch) {
        const formattedDate = formatDate(dateMatch[0]);
        return line.replace(dateMatch[0], formattedDate);
      }
  
      return line;
    });
  
    return { __html: formattedLines.join("<br>") };
  }
  

  function formatDate(dateStr) {
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6, 8);
    return `${day}/${month}/${year}`;
  }
  
class QueryTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

     
      

    render() {
      const authServices = new AuthService();

        return (
            <Grid padded stackable columns='equal' verticalAlign='top'>
                <Grid.Row>
                    <Grid.Column>
                        <Field label={"Date Logged"} value={<FormattedDate value={this.props.data.dateLogged} inputFormat="YYYY-MM-DDThh:mm:ss"/>} />
                       
                    </Grid.Column>
                    <Grid.Column>
                        <Field label={"Raised By"} value={this.props.data.addedBy}/>
                        <Field label={"Next Action By"} value={this.props.data.toBeActionedBy}/>
                    </Grid.Column>

                    <Grid.Column>
                        <Field label={"Status"} value={this.props.status}/>
                        {this.props.data.dateCompleted !== "0001-01-01T00:00:00" && 
                        <Field label={"Date Completed"} value={<FormattedDate value={this.props.data.dateCompleted} inputFormat="YYYY-MM-DDThh:mm:ss"/>}/>
                        }
                    </Grid.Column>
                    {(this.props.data.siteNumber || this.props.data.siteName || this.props.data.division || this.props.data.productGroup || this.props.data.supplier || this.props.data.supplierRef || this.props.data.m_NoPan) && (
    <Grid.Column>
      <h3>Site and Meter Details</h3>
      {this.props.data.siteNumber && <Field label={"Site Number"} value={this.props.data.siteNumber} />}
      {this.props.data.siteName && <Field label={"Site Name"} value={this.props.data.siteName} />}
      {this.props.data.Division && <Field label={"Division"} value={this.props.data.division} />}
      {this.props.data.division && <Field label={"Product Group"} value={this.props.data.productGroup} />}
      {this.props.data.supplier && <Field label={"Supplier"} value={this.props.data.supplier} />}
      {this.props.data.supplierRef && <Field label={"Supplier Ref"} value={this.props.data.supplierRef} />}
      {this.props.data.m_NoPan && <Field label={"M_No/Pan"} value={this.props.data.m_NoPan} />}
      {this.props.data.siteAddress && <Field label={"Site Address"} value={this.props.data.siteAddress} />}
      {this.props.data.meterSiteAddress && <Field label={"Meter Address"} value={this.props.data.meterSiteAddress} />}

    </Grid.Column>
  )}
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                    {(authServices.hasCaseManActive(this.props.data.customerId)) &&
                    <CaseUpdate queryKey={this.props.data.queryKey}></CaseUpdate>
    }
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                    <Container textAlign='justified'>
      <b>{this.props.data.description}</b>
      <Divider />
      <p>
      {this.props.data.querySummary 
    ? <div dangerouslySetInnerHTML={convertNewlineToBreakWithFormattedDate(this.props.data.querySummary)} />
    : this.props.status === 'Closed'
      ? "This query is now closed. Should you have any further concerns or questions, please feel free to reach out to us."
      : "We are working behind the scenes to resolve your query and will provide an update in due course"
  }
      </p>
     
    </Container>

                        
                        {/* <Field label={"Description"} value={this.props.data.description}/>
                        <Field label={"Summary"} value={this.props.data.querySummary}/> */}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }

    componentDidMount = () => {
    }

}

export default QueryTab;